import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Input, FormText } from "reactstrap";
import classnames from "classnames";
import { IconEye, IconEyeOff, IconLock } from "@sfx/icons";

var PasswordMask = /*#__PURE__*/function (_Component) {
  _inherits(PasswordMask, _Component);

  var _super = _createSuper(PasswordMask);

  function PasswordMask() {
    var _this;

    _classCallCheck(this, PasswordMask);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      masked: true,
      passwordValue: _this.props.value || ""
    });

    _defineProperty(_assertThisInitialized(_this), "handleEyeClick", function () {
      _this.setState({
        masked: !_this.state.masked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePasswordChange", function (e) {
      e.persist();
      var val = e.target.value;

      _this.setState({
        passwordValue: val
      }, function () {
        if (_this.props.onChange) {
          // return event so this param can be used to debounce
          _this.props.onChange(e);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePasswordBlur", function (e) {
      var val = e.target.value;

      if (_this.props.onBlur) {
        _this.props.onBlur(val);
      }
    });

    return _this;
  }

  _createClass(PasswordMask, [{
    key: "render",
    value: function render() {
      var innerEye = this.props.lock ? /*#__PURE__*/React.createElement("span", {
        className: classnames(this.props.className, {
          "input-group-text": this.props.bootstrapDefaultStyle
        }, {
          "outline-0 px-3 d-flex align-items-center": !this.props.bootstrapDefaultStyle
        })
      }, /*#__PURE__*/React.createElement(IconLock, {
        size: "16"
      })) : /*#__PURE__*/React.createElement("span", {
        onClick: this.handleEyeClick,
        className: classnames(this.props.className, {
          "input-group-text": this.props.bootstrapDefaultStyle
        }, {
          "outline-0 px-3 d-flex align-items-center": !this.props.bootstrapDefaultStyle
        })
      }, this.state.masked && /*#__PURE__*/React.createElement(IconEye, {
        size: "16"
      }), !this.state.masked && /*#__PURE__*/React.createElement(IconEyeOff, {
        size: "16"
      }));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classnames(this.props.className, {
          "input-group": this.props.bootstrapDefaultStyle
        }, {
          "d-flex align-items-center": !this.props.bootstrapDefaultStyle
        }),
        id: "show_hide_password"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          position: "absolute",
          top: "-30px",
          right: "0"
        }
      }, this.props.children), /*#__PURE__*/React.createElement(Input, {
        type: this.state.masked ? "password" : "text",
        className: classnames(this.props.className, {
          "outline-0": !this.props.bootstrapDefaultStyle
        }),
        name: this.props.fieldName,
        placeholder: this.props.placeHolder,
        "data-toggle": "password",
        defaultValue: this.state.passwordValue,
        onChange: this.handlePasswordChange,
        onBlur: this.handlePasswordBlur,
        invalid: this.props.invalid,
        disabled: this.props.disabled
      }), this.props.bootstrapDefaultStyle && /*#__PURE__*/React.createElement("div", {
        className: "input-group-append"
      }, innerEye), !this.props.bootstrapDefaultStyle && /*#__PURE__*/React.createElement(React.Fragment, null, innerEye)), this.props.showErrorMsg && /*#__PURE__*/React.createElement(FormText, null, this.props.errorMessage));
    }
  }]);

  return PasswordMask;
}(Component);

PasswordMask.propTypes = {
  fieldName: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  handleChange: PropTypes.func,
  className: PropTypes.string,
  bootstrapDefaultStyle: PropTypes.bool,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  placeHolder: PropTypes.string
};
PasswordMask.defaultProps = {
  className: "",
  bootstrapDefaultStyle: true,
  placeHolder: "Password"
};
export default PasswordMask;